import React from 'react';
import ChartWithAnnotations from './ChartWithAnnotations';

class BarChartWithAnnotations extends React.Component {
    render(){
        return <ChartWithAnnotations chartType="bar" {...this.props} />    
    }
}

export default BarChartWithAnnotations